import PropTypes from "prop-types";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

// Valeurs par défaut dans la signature : `defaultProps` est déprécié sur les
// composants fonction et supprimé à partir de React 19.
const MyGallery = ({
  images,
  thumbnailPosition = "bottom",
  autoPlay = false,
  lazyLoad = false,
}) => (
  <ImageGallery
    items={images}
    thumbnailPosition={thumbnailPosition}
    autoPlay={autoPlay}
    lazyLoad={lazyLoad}
  />
);

MyGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      original: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired,
      originalAlt: PropTypes.string,
      thumbnailAlt: PropTypes.string,
    })
  ).isRequired,
  thumbnailPosition: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  autoPlay: PropTypes.bool,
  lazyLoad: PropTypes.bool,
};

export default MyGallery;
